import { ChemicalRobItemBM } from '../../types/BusinessModel/TankCleaning/ChemicalRobItemBM';
import { ChemicalRobItem } from '../../types/ViewModel/TankCleaning/ROB/ChemicalRobItem';
import { createRobLocationBMItemList } from './ChemicalRobLocationItemFactory';

export const createChemicalRobItem = (chemicalRobItem: ChemicalRobItemBM): ChemicalRobItem => {
    return {
        chemicalRobItemId: chemicalRobItem.chemicalRobItemId,
        chemicalId: chemicalRobItem.chemicalId,
        robValue: chemicalRobItem.robValue,
        chemicalRobItemLocationList: chemicalRobItem.chemicalRobItemLocationList,
    };
};

export const createChemicalRobList = (chemicalRobs: ChemicalRobItemBM[]) => chemicalRobs.map((chemicalRob) => createChemicalRobItem(chemicalRob));

export const createChemicalRobItemBM = (chemicalRobItem: ChemicalRobItem): ChemicalRobItemBM => {
    return {
        chemicalRobItemId: chemicalRobItem.chemicalRobItemId,
        chemicalId: chemicalRobItem.chemicalId,
        robValue: chemicalRobItem.robValue,
        chemicalRobItemLocationList: createRobLocationBMItemList(chemicalRobItem.chemicalRobItemLocationList),
    };
};

export const createChemicalRobListBM = (chemicalRobs: ChemicalRobItem[]) => chemicalRobs.map((chemicalRob) => createChemicalRobItemBM(chemicalRob));
